<div class="form-group mb-0">
    <label>{{ fieldObject.fieldName }}</label>
    <input type="text" class="form-control"
      [formControl]="formControlRef"/>
    <small class="text-danger"
           *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
      {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
    </small>
  </div>
